import type { RefAttributes } from 'react';

import { Button } from 'antd';
import type { ButtonProps } from 'antd/es/button';
import type { LinkProps } from 'react-router';
import { useHref, useLinkClickHandler } from 'react-router';

interface RouterButtonProps
  extends
    ButtonProps,
    Pick<LinkProps, 'replace' | 'state' | 'to'>,
    RefAttributes<HTMLButtonElement | HTMLAnchorElement> {}

export const RouterButton = ({
  onClick,
  replace = false,
  state,
  target,
  to,
  children,
  ref,
  ...rest
}: RouterButtonProps) => {
  const href = useHref(to);
  const handleClick = useLinkClickHandler(to, { replace, state, target });

  return (
    <Button
      {...rest}
      href={href}
      onClick={(event) => {
        onClick?.(event);
        if (!event.defaultPrevented) {
          handleClick(event as $IntentionalAny);
        }
      }}
      ref={ref}
      target={target}
    >
      {children}
    </Button>
  );
};
